<div class="card-body">
    <div id="traffic-source-chart"></div>
</div>